module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list', {
    attrs: {
      "moduleIdentifier": _vm.identifier,
      "listTitle": _vm.$t((_vm.identifier + ".attributes.label")),
      "filter-title": "Filtros",
      "loading": _vm.loadingAttributes || _vm.loadingCategories,
      "typesListAvailable": ['displayList'],
      "total": _vm.total,
      "sortFields": ['label'],
      "sortDefault": {
        field: 'label',
        order: 'desc'
      }
    },
    on: {
      "change": _vm.onChange,
      "clearFilters": _vm.clearFilters
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-actions"
    },
    slot: "header-actions"
  }, [_c('button', {
    staticClass: "btn btn--info",
    on: {
      "click": _vm.addAttribute
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('template', {
    slot: "filters"
  }, [_c('form-group', {
    attrs: {
      "label": "Nome",
      "columns": 6
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.label),
      expression: "options.label"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.options.label)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "label", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Categorias",
      "columns": 6
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.marketplaceCategories,
      "label": "label",
      "track-by": "code",
      "selectLabel": "",
      "selectedLabel": "",
      "multiple": true,
      "placeholder": "Todas"
    },
    model: {
      value: (_vm.categoriesSelect),
      callback: function($$v) {
        _vm.categoriesSelect = $$v
      },
      expression: "categoriesSelect"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.attributes), function(attribute) {
    return _c('div', {
      key: attribute,
      staticClass: "l-col-12@md"
    }, [_c('attribute-card', {
      attrs: {
        "identifier": _vm.identifier,
        "attribute": attribute
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-193739c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MarketplaceAttribute/List.vue
// module id = 2947
// module chunks = 0